import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-arrow-up',
  templateUrl: './icon-arrow-up.component.html',
  styleUrls: ['./icon-arrow-up.component.scss']
})
export class IconArrowUpComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
